<template>
  <select :value="modelValue" class="form-select" @input="$emit('update:modelValue', $event.target.value)">
    <option value="0">
      {{ $t("valorTotal") }}
    </option>
    <option value="1">
      {{ $t("valorProdutos") }}
    </option>
    <option value="2">
      {{ $t("valorServicos") }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    modelValue: { type: String, required: true },
  },
  emits: ['update:modelValue'],
};
</script>
